import { StyledAdminListRowCell } from './styles';
interface IAdminListRowCellProps {
  children?: React.ReactNode;
}
export const AdminListRowCell = ({ children }: IAdminListRowCellProps) => {
  return <StyledAdminListRowCell>{children}</StyledAdminListRowCell>;
};
